import { type ReactNode, type Ref, use } from 'react'
import { Accordion as BaseAccordion } from '@base-ui/react/accordion'

import { cn } from '@gto/ui/cn'

import { type AccordionVariant, accordionVariants } from './accordion.styles'
import { AccordionVariantContext } from './accordion-context'

export type ContentProps = {
  /** Override the variant inherited from `Accordion.Root`. */
  variant?: AccordionVariant
  children?: ReactNode
  className?: string
  ref?: Ref<HTMLDivElement>
}

export const Content = ({ variant: variantProp, children, className, ref }: ContentProps) => {
  const variant = variantProp ?? use(AccordionVariantContext)
  const { panel, contentInner } = accordionVariants({ variant })

  return (
    <BaseAccordion.Panel
      ref={ref}
      className={panel()}
    >
      <div className={cn(contentInner(), className)}>{children}</div>
    </BaseAccordion.Panel>
  )
}
